var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tabs',{attrs:{"color":"#244485","show-arrows":false,"background-color":"transparent"},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},_vm._l((_vm.items),function(item){return _c('v-tab',{key:item},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }